export default __webpack_public_path__ + "static/media/alert.50db65c3.svg";